import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatFullTime } from '../../../../utils/messageRenderUtils';
import MessageInfoSection from '../MessageInfoSection/MessageInfoSection';
import { getMessageDetailsThemeColors } from '../MessageDetails.helpers';

const { Text } = Typography;

const STATUS_FLAGS = [
    { key: 'sent', successColor: 'green' },
    { key: 'delivered', successColor: 'green' },
    { key: 'read', successColor: 'green' },
    { key: 'failed', successColor: 'red' },
    { key: 'edited', successColor: 'blue' },
];

const MessageBasicInfo = ({ message, isDarkMode }) => {
    const { t, i18n } = useTranslation();
    const themeColors = getMessageDetailsThemeColors(isDarkMode);

    if (!message) return null;

    return (
        <MessageInfoSection title={t('basic_information')}>
            <Space direction="vertical">
                <Text style={{ color: themeColors.text }}>{t('id')}: {message.id}</Text>
                <Text style={{ color: themeColors.text }}>{t('sender_type')}: {message.sender_type}</Text>
                <Text style={{ color: themeColors.text }}>{t('sent_at')}: {formatFullTime(message.status?.sent_at, i18n?.language)}</Text>
                {message.has_ticket && <Tag color="red">{t('has_ticket')}</Tag>}
                {message.is_abuse && <Tag color="red">{t('marked_as_abusive')}</Tag>}
                <Space size={[0, 8]} wrap style={{ marginTop: 8 }}>
                    {STATUS_FLAGS.map(({ key, successColor }) => {
                        const active = Boolean(message.status?.[key]);
                        return (
                            <Tag key={key} color={active ? successColor : 'default'}>
                                {t(key)}: {active ? t('yes') : t('no')}
                            </Tag>
                        );
                    })}
                </Space>
            </Space>
        </MessageInfoSection>
    );
};

export default MessageBasicInfo;
